<template>
  <div id="app" v-show="loading">
    <entete v-show="loading"></entete>
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <foot v-show="loading"></foot>
  </div>
</template>
<script>
import Vue from 'vue'
import entete from './components/Header/Header.vue'
import foot from './components/footer'
import { Loading, Notification } from 'element-ui'
import('./assets/sass/main.sass')
Vue.prototype.$notify = Notification
export default {
  name: 'app',
  components: {
    entete,
    foot
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
    })
  },
  created () {
    // do something after mounting vue instance
    let loadingInstance = Loading.service({ fullscreen: true })
    setTimeout(() => {
      loadingInstance.close()
      this.loading = true
    }, 2000)
    // me.$nextTick(() => { // Loading should be closed asynchronously
    //
    // })
  },
  mounted () {
    if (process.env.NODE_ENV === 'production') {
      (() => {
        (function (f, b, e, v, n, t, s) {
          if (f.fbq) return; n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
          }; if (!f._fbq) f._fbq = n
          n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0
          t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s)
        })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', undefined, undefined, undefined)
        /* eslint-disable no-undef */
        fbq('init', '1451065708358741')
        fbq('init', '461802636222242')
        fbq('track', 'PageView')
        /* eslint-enable no-undef */
      })()
    }
  },
  data () {
    return {
      loading: false
    }
  }
}
</script>
<style>
.el-loading-mask {
    background-color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue